import React from "react";
import PropTypes from "prop-types";

import Image from "../image/Image";
import "./Buttons.scss";

function Buttons(props) {
  const {
    titleText,
    isLoading,
    buttonTypeClassName,
    onClick,
    textWithIcon,
    buttonText,
    imagePath,
    isDisable,
  } = props;

  return (
    <button
      type="submit"
      className={`btn ${buttonTypeClassName} ${isDisable ? "disable-btn" : ""}`}
      onClick={onClick}
      disabled={isLoading || isDisable}
      title={titleText}
    >
      {isLoading ? (
        <div className="button-loading-part"></div>
      ) : (
        <>
          {textWithIcon && (
            <Image
              imgCustomClassName="front-btn-img"
              imagePath={imagePath}
              altText="button Icon"
            />
          )}
          <span>{textWithIcon && buttonText}</span>
          {!textWithIcon && buttonText}
        </>
      )}
    </button>
  );
}

Buttons.propTypes = {
  titleText: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonTypeClassName: PropTypes.string,
  onClick: PropTypes.func,
  textWithIcon: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  imagePath: PropTypes.string,
  isDisable: PropTypes.bool,
};

export default Buttons;
